import {
  registerOnErrorHandler,
  registerUnhandledPromiseRejectionHandler,
} from '@shopify/bugsnag-light-core';

import {Bugsnag} from './bugsnag';

// Report unhandled errors and unhandled promise rejection to Bugsnag
registerOnErrorHandler(Bugsnag);
registerUnhandledPromiseRejectionHandler(Bugsnag);
